<template>
  <tr>
    <td class="text-left" :data-label="translate('server.instance_group.name')">{{ group.name }}</td>
    <td class="w15per" :data-label="translate('server.servers_count')">{{ group.servers_count }}</td>
    <td class="w100">
      <div class="buttons">
        <span class="btn btn-info btn-icon" :aria-label="translate('simcard_devices.edit')" :title="translate('simcard_devices.edit')" @click="$emit('edit_group')">
          <i class="mdi mdi-pencil" />
        </span>
        <span class="btn btn-danger btn-icon" :aria-label="translate('group.del')" :title="translate('group.del')" @click="deleteGroup">
          <i class="mdi mdi-delete" />
        </span>
      </div>
    </td>
  </tr>
</template>
<script>

import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'ServerGroupItem',
  props: {
    group: Object
  },
  methods: {
    deleteGroup () {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('server.delete.group') + '?'
        },
        on: {
          close: () => {
            this.$modal.hide('delete_server_group')
          },
          confirm: () => {
            this.$emit('del_group', this.group.id)
            this.$modal.hide('delete_server_group')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'delete_server_group'})
    },
  }
}
</script>

<style lang="scss" scoped>
.buttons{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  span{
    padding: 2px 10px;
  }
}
</style>
